module.exports = __webpack_public_path__ + "img/banner.V=0.1.0_202601151459.webp";